import { Box, CssBaseline, Paper, Stack, Toolbar } from '@mui/material';
import NavigationBar from './Navigation/NavigationBar';
import NavigationDrawer from './Navigation/NavigationDrawer';
import { Redirect, Route, Switch } from 'react-router-dom';
import AppBreadcrumb from './AppBreadcrumb/AppBreadcrumb';
import routes from '../../router/routes';
import Footer from './Footer/Footer';
import DemoBar from './DemoBar';
import Tutorial from '../../tutorial/tutorial';

const Layout = (): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <Tutorial />
      <CssBaseline />
      <div className='globalTutorialAnchor'></div>
      <NavigationBar />
      <NavigationDrawer />
      <Stack direction="column" margin={0} justifyContent="flex-start" spacing={1} sx={{ mt: 8, p: 1, width: '100%' }}>
        {/* <Toolbar /> */}
        <DemoBar />
        <Paper elevation={2} sx={{ px: 2, py: 1 }}>
          <AppBreadcrumb />
        </Paper>
        <Switch>
          {routes.map(({ path, Component }, key) => (
            <Route key={key} exact path={path} render={props => <Component key={key} {...props.match.params} />} />
          ))}
        </Switch>
        <Paper sx={{ px: 1, py: 2 }}>
          <Footer />
        </Paper>
      </Stack>
    </Box>
  );
};

export default Layout;
